import { createElement, Component } from 'react';
import { Surface, Symbols, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line, ComposedChart, Bar, Area, Cell, ResponsiveContainer, PieChart, Pie } from 'recharts';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var randomColor = createCommonjsModule(function (module, exports) {
(function(root, factory) {

  // Support CommonJS
  {
    var randomColor = factory();

    // Support NodeJS & Component, which allow module.exports to be a function
    if (module && module.exports) {
      exports = module.exports = randomColor;
    }

    // Support CommonJS 1.1.1 spec
    exports.randomColor = randomColor;

  // Support AMD
  }

}(commonjsGlobal, function() {

  // Seed to get repeatable colors
  var seed = null;

  // Shared color dictionary
  var colorDictionary = {};

  // Populate the color dictionary
  loadColorBounds();

  var randomColor = function (options) {

    options = options || {};

    // Check if there is a seed and ensure it's an
    // integer. Otherwise, reset the seed value.
    if (options.seed !== undefined && options.seed !== null && options.seed === parseInt(options.seed, 10)) {
      seed = options.seed;

    // A string was passed as a seed
    } else if (typeof options.seed === 'string') {
      seed = stringToInteger(options.seed);

    // Something was passed as a seed but it wasn't an integer or string
    } else if (options.seed !== undefined && options.seed !== null) {
      throw new TypeError('The seed value must be an integer or string');

    // No seed, reset the value outside.
    } else {
      seed = null;
    }

    var H,S,B;

    // Check if we need to generate multiple colors
    if (options.count !== null && options.count !== undefined) {

      var totalColors = options.count,
          colors = [];

      options.count = null;

      while (totalColors > colors.length) {

        // Since we're generating multiple colors,
        // incremement the seed. Otherwise we'd just
        // generate the same color each time...
        if (seed && options.seed) options.seed += 1;

        colors.push(randomColor(options));
      }

      options.count = totalColors;

      return colors;
    }

    // First we pick a hue (H)
    H = pickHue(options);

    // Then use H to determine saturation (S)
    S = pickSaturation(H, options);

    // Then use S and H to determine brightness (B).
    B = pickBrightness(H, S, options);

    // Then we return the HSB color in the desired format
    return setFormat([H,S,B], options);
  };

  function pickHue (options) {

    var hueRange = getHueRange(options.hue),
        hue = randomWithin(hueRange);

    // Instead of storing red as two seperate ranges,
    // we group them, using negative numbers
    if (hue < 0) {hue = 360 + hue;}

    return hue;

  }

  function pickSaturation (hue, options) {

    if (options.hue === 'monochrome') {
      return 0;
    }

    if (options.luminosity === 'random') {
      return randomWithin([0,100]);
    }

    var saturationRange = getSaturationRange(hue);

    var sMin = saturationRange[0],
        sMax = saturationRange[1];

    switch (options.luminosity) {

      case 'bright':
        sMin = 55;
        break;

      case 'dark':
        sMin = sMax - 10;
        break;

      case 'light':
        sMax = 55;
        break;
   }

    return randomWithin([sMin, sMax]);

  }

  function pickBrightness (H, S, options) {

    var bMin = getMinimumBrightness(H, S),
        bMax = 100;

    switch (options.luminosity) {

      case 'dark':
        bMax = bMin + 20;
        break;

      case 'light':
        bMin = (bMax + bMin)/2;
        break;

      case 'random':
        bMin = 0;
        bMax = 100;
        break;
    }

    return randomWithin([bMin, bMax]);
  }

  function setFormat (hsv, options) {

    switch (options.format) {

      case 'hsvArray':
        return hsv;

      case 'hslArray':
        return HSVtoHSL(hsv);

      case 'hsl':
        var hsl = HSVtoHSL(hsv);
        return 'hsl('+hsl[0]+', '+hsl[1]+'%, '+hsl[2]+'%)';

      case 'hsla':
        var hslColor = HSVtoHSL(hsv);
        var alpha = options.alpha || Math.random();
        return 'hsla('+hslColor[0]+', '+hslColor[1]+'%, '+hslColor[2]+'%, ' + alpha + ')';

      case 'rgbArray':
        return HSVtoRGB(hsv);

      case 'rgb':
        var rgb = HSVtoRGB(hsv);
        return 'rgb(' + rgb.join(', ') + ')';

      case 'rgba':
        var rgbColor = HSVtoRGB(hsv);
        var alpha = options.alpha || Math.random();
        return 'rgba(' + rgbColor.join(', ') + ', ' + alpha + ')';

      default:
        return HSVtoHex(hsv);
    }

  }

  function getMinimumBrightness(H, S) {

    var lowerBounds = getColorInfo(H).lowerBounds;

    for (var i = 0; i < lowerBounds.length - 1; i++) {

      var s1 = lowerBounds[i][0],
          v1 = lowerBounds[i][1];

      var s2 = lowerBounds[i+1][0],
          v2 = lowerBounds[i+1][1];

      if (S >= s1 && S <= s2) {

         var m = (v2 - v1)/(s2 - s1),
             b = v1 - m*s1;

         return m*S + b;
      }

    }

    return 0;
  }

  function getHueRange (colorInput) {

    if (typeof parseInt(colorInput) === 'number') {

      var number = parseInt(colorInput);

      if (number < 360 && number > 0) {
        return [number, number];
      }

    }

    if (typeof colorInput === 'string') {

      if (colorDictionary[colorInput]) {
        var color = colorDictionary[colorInput];
        if (color.hueRange) {return color.hueRange;}
      } else if (colorInput.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
        var hue = HexToHSB(colorInput)[0];
        return [ hue, hue ];
      }
    }

    return [0,360];

  }

  function getSaturationRange (hue) {
    return getColorInfo(hue).saturationRange;
  }

  function getColorInfo (hue) {

    // Maps red colors to make picking hue easier
    if (hue >= 334 && hue <= 360) {
      hue-= 360;
    }

    for (var colorName in colorDictionary) {
       var color = colorDictionary[colorName];
       if (color.hueRange &&
           hue >= color.hueRange[0] &&
           hue <= color.hueRange[1]) {
          return colorDictionary[colorName];
       }
    } return 'Color not found';
  }

  function randomWithin (range) {
    if (seed === null) {
      return Math.floor(range[0] + Math.random()*(range[1] + 1 - range[0]));
    } else {
      //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
      var max = range[1] || 1;
      var min = range[0] || 0;
      seed = (seed * 9301 + 49297) % 233280;
      var rnd = seed / 233280.0;
      return Math.floor(min + rnd * (max - min));
    }
  }

  function HSVtoHex (hsv){

    var rgb = HSVtoRGB(hsv);

    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);

    return hex;

  }

  function defineColor (name, hueRange, lowerBounds) {

    var sMin = lowerBounds[0][0],
        sMax = lowerBounds[lowerBounds.length - 1][0],

        bMin = lowerBounds[lowerBounds.length - 1][1],
        bMax = lowerBounds[0][1];

    colorDictionary[name] = {
      hueRange: hueRange,
      lowerBounds: lowerBounds,
      saturationRange: [sMin, sMax],
      brightnessRange: [bMin, bMax]
    };

  }

  function loadColorBounds () {

    defineColor(
      'monochrome',
      null,
      [[0,0],[100,0]]
    );

    defineColor(
      'red',
      [-26,18],
      [[20,100],[30,92],[40,89],[50,85],[60,78],[70,70],[80,60],[90,55],[100,50]]
    );

    defineColor(
      'orange',
      [19,46],
      [[20,100],[30,93],[40,88],[50,86],[60,85],[70,70],[100,70]]
    );

    defineColor(
      'yellow',
      [47,62],
      [[25,100],[40,94],[50,89],[60,86],[70,84],[80,82],[90,80],[100,75]]
    );

    defineColor(
      'green',
      [63,178],
      [[30,100],[40,90],[50,85],[60,81],[70,74],[80,64],[90,50],[100,40]]
    );

    defineColor(
      'blue',
      [179, 257],
      [[20,100],[30,86],[40,80],[50,74],[60,60],[70,52],[80,44],[90,39],[100,35]]
    );

    defineColor(
      'purple',
      [258, 282],
      [[20,100],[30,87],[40,79],[50,70],[60,65],[70,59],[80,52],[90,45],[100,42]]
    );

    defineColor(
      'pink',
      [283, 334],
      [[20,100],[30,90],[40,86],[60,84],[80,80],[90,75],[100,73]]
    );

  }

  function HSVtoRGB (hsv) {

    // this doesn't work for the values of 0 and 360
    // here's the hacky fix
    var h = hsv[0];
    if (h === 0) {h = 1;}
    if (h === 360) {h = 359;}

    // Rebase the h,s,v values
    h = h/360;
    var s = hsv[1]/100,
        v = hsv[2]/100;

    var h_i = Math.floor(h*6),
      f = h * 6 - h_i,
      p = v * (1 - s),
      q = v * (1 - f*s),
      t = v * (1 - (1 - f)*s),
      r = 256,
      g = 256,
      b = 256;

    switch(h_i) {
      case 0: r = v; g = t; b = p;  break;
      case 1: r = q; g = v; b = p;  break;
      case 2: r = p; g = v; b = t;  break;
      case 3: r = p; g = q; b = v;  break;
      case 4: r = t; g = p; b = v;  break;
      case 5: r = v; g = p; b = q;  break;
    }

    var result = [Math.floor(r*255), Math.floor(g*255), Math.floor(b*255)];
    return result;
  }

  function HexToHSB (hex) {
    hex = hex.replace(/^#/, '');
    hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;

    var red = parseInt(hex.substr(0, 2), 16) / 255,
          green = parseInt(hex.substr(2, 2), 16) / 255,
          blue = parseInt(hex.substr(4, 2), 16) / 255;

    var cMax = Math.max(red, green, blue),
          delta = cMax - Math.min(red, green, blue),
          saturation = cMax ? (delta / cMax) : 0;

    switch (cMax) {
      case red: return [ 60 * (((green - blue) / delta) % 6) || 0, saturation, cMax ];
      case green: return [ 60 * (((blue - red) / delta) + 2) || 0, saturation, cMax ];
      case blue: return [ 60 * (((red - green) / delta) + 4) || 0, saturation, cMax ];
    }
  }

  function HSVtoHSL (hsv) {
    var h = hsv[0],
      s = hsv[1]/100,
      v = hsv[2]/100,
      k = (2-s)*v;

    return [
      h,
      Math.round(s*v / (k<1 ? k : 2-k) * 10000) / 100,
      k/2 * 100
    ];
  }

  function stringToInteger (string) {
    var total = 0;
    for (var i = 0; i !== string.length; i++) {
      if (total >= Number.MAX_SAFE_INTEGER) break;
      total += string.charCodeAt(i);
    }
    return total
  }

  return randomColor;
}));
});
var randomColor_1 = randomColor.randomColor;

var ChartLegendContent = /** @class */ (function (_super) {
    __extends(ChartLegendContent, _super);
    function ChartLegendContent(props) {
        var _this = _super.call(this, props) || this;
        _this.iconSize = 32;
        _this.handleLegendItemClick = function (serie) {
            var _a;
            _this.setState({
                offSeries: __assign({}, _this.state.offSeries, (_a = {}, _a[serie.key] = !_this.state.offSeries[serie.key], _a)),
            });
            if (_this.props.onItemClick) {
                _this.props.onItemClick(serie);
            }
        };
        _this.state = {
            offSeries: {},
        };
        return _this;
    }
    ChartLegendContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, align = _a.align, iconSize = _a.iconSize;
        return (createElement("div", { className: "customized-legend", style: {
                textAlign: align,
            } }, this.props.series &&
            this.props.series.map(function (serie, index) {
                var key = serie.key, label = serie.label, color = serie.color;
                var inactive = !!_this.state.offSeries[key];
                var margin = {
                    left: "0 16px 0 0",
                    right: "0 0 0 16px",
                    center: "0 8px 0 8px",
                };
                var itemStyles = {
                    margin: margin[align || "center"],
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                };
                return (createElement("span", { key: "legend-item-" + index, className: classnames("recharts-legend-item", inactive && "inactive", inactive && classes && classes.itemInactive), onClick: function () {
                        return _this.handleLegendItemClick(serie);
                    }, style: itemStyles },
                    createElement(Surface, { width: iconSize, height: iconSize, viewBox: {
                            x: 0,
                            y: 0,
                            width: _this.iconSize,
                            height: _this.iconSize,
                        }, style: {
                            marginRight: 4,
                        } }, _this.renderIcon(serie, inactive)),
                    createElement("span", null, label || key)));
            })));
    };
    ChartLegendContent.prototype.renderIcon = function (serie, inactive) {
        if (inactive === void 0) { inactive = false; }
        var halfSize = this.iconSize / 2;
        var sixthSize = this.iconSize / 6;
        var thirdSize = this.iconSize / 3;
        var color = serie.color;
        if (!serie.legendIconType) {
            if (serie.type === "line") {
                // show line as the legend icon
                return inactive ? (createElement("path", { strokeWidth: 4, fill: "none", stroke: "#9e9e9e", d: "M0," + halfSize + "h" + thirdSize + "\n                                A" + sixthSize + "," + sixthSize + ",0,1,1," + 2 *
                        thirdSize + "," + halfSize + "\n                                H" + this.iconSize + "M" + 2 * thirdSize + "," + halfSize + "\n                                A" + sixthSize + "," + sixthSize + ",0,1,1," + thirdSize + "," + halfSize, className: "recharts-legend-icon" })) : (createElement("path", { strokeWidth: 4, fill: "none", stroke: color, d: "M0," + halfSize + "h" + thirdSize + "\n                                A" + sixthSize + "," + sixthSize + ",0,1,1," + 2 *
                        thirdSize + "," + halfSize + "\n                                H" + this.iconSize + "M" + 2 * thirdSize + "," + halfSize + "\n                                A" + sixthSize + "," + sixthSize + ",0,1,1," + thirdSize + "," + halfSize, className: "recharts-legend-icon" }));
            }
            else {
                // for area, bar show rect legend
                return inactive ? (createElement("path", { strokeWidth: 4, stroke: color, fill: "none", d: "M0," + sixthSize + "h" + this.iconSize + "v" + halfSize + "h" + -this
                        .iconSize + "z", className: "recharts-legend-icon" })) : (createElement("path", { stroke: "none", fill: color, d: "M0," + sixthSize + "h" + this.iconSize + "v" + halfSize + "h" + -this
                        .iconSize + "z", className: "recharts-legend-icon" }));
            }
        }
        return inactive ? (createElement(Symbols, { fill: "none", strokeWidth: 4, stroke: color, cx: halfSize, cy: halfSize, size: this.iconSize - 10, sizeType: "diameter", type: serie.legendIconType })) : (createElement(Symbols, { fill: color, cx: halfSize, cy: halfSize, size: this.iconSize - 10, sizeType: "diameter", type: serie.legendIconType }));
    };
    return ChartLegendContent;
}(Component));

var Chart = /** @class */ (function (_super) {
    __extends(Chart, _super);
    function Chart(props) {
        var _this = _super.call(this, props) || this;
        _this.onLegendClick = function (options) {
            if (_this.props.onLegendClick) {
                _this.props.onLegendClick(options);
            }
        };
        _this.onLegentItemClick = function (serie) {
            var _a;
            var dataKey = serie.key;
            _this.setState({
                offSeries: __assign({}, _this.state.offSeries, (_a = {}, _a[dataKey] = !_this.state.offSeries[dataKey], _a)),
            });
        };
        _this.renderCromposedChart = function () {
            var classes = _this.props.classes;
            return (createElement(ResponsiveContainer, { width: "100%", height: "100%" },
                createElement(ComposedChart, { data: _this.state.data },
                    createElement(XAxis, { dataKey: _this.props.xKey, height: _this.props.xHeight }),
                    createElement(YAxis, { width: _this.state.data && _this.state.data.length > 0 ? _this.props.yWidth : 0 }),
                    createElement(CartesianGrid, { vertical: false, strokeDasharray: "3 3" }),
                    _this.props.data && _this.props.data.length > 0 && createElement(Tooltip, null),
                    !_this.props.hideLegend &&
                        createElement(Legend, { height: _this.props.legendHeight || 45, iconType: _this.props.legendItemIconType || "square", onClick: _this.onLegendClick, content: function (props) { return (createElement(ChartLegendContent, __assign({}, props, { series: _this.props.series, onItemClick: _this.onLegentItemClick, classes: {
                                    itemInactive: classes && classes.legendItemInactive,
                                } }))); } }),
                    _this.props.series &&
                        _this.props.series.map(function (serie, index) {
                            if (_this.state.offSeries[serie.key]) {
                                return;
                            }
                            switch (serie.type) {
                                case "area":
                                    return createElement(Area, { key: index, type: serie.visualizationType || "monotone", dataKey: serie.key, fill: serie.color, stroke: serie.color });
                                case "bar":
                                    return createElement(Bar, { key: index, dataKey: serie.key, barSize: serie.width || 20, fill: serie.color });
                                case "line":
                                default:
                                    return createElement(Line, { key: index, type: serie.visualizationType || "monotone", dataKey: serie.key, stroke: serie.color });
                            }
                        }))));
        };
        _this.renderPieChart = function () {
            // const { classes } = this.props;
            var count = _this.props.data.length;
            var colored = count === 1;
            var itemWidthUnit = 100 / count;
            var RADIAN = Math.PI / 180;
            var renderCustomizedLabel = function (_a) {
                var cx = _a.cx, cy = _a.cy, midAngle = _a.midAngle, innerRadius = _a.innerRadius, outerRadius = _a.outerRadius, percent = _a.percent, index = _a.index;
                var radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                var x = cx + radius * Math.cos(-midAngle * RADIAN);
                var y = cy + radius * Math.sin(-midAngle * RADIAN);
                return (createElement("text", { x: x, y: y, fill: "white", textAnchor: x > cx ? "start" : "end", dominantBaseline: "central" }, (percent * 100).toFixed(0) + "%"));
            };
            return (createElement(PieChart, { width: 730, height: 250 },
                _this.props.data &&
                    _this.props.data.map(function (d, index) {
                        var serie = _this.props.series[index];
                        var innerRadius = index === 0 ? 0 : itemWidthUnit * index * 1.2 + "%";
                        var outerRadius = index === 0 ? itemWidthUnit + "%" : itemWidthUnit * index * 1.5 + "%";
                        return (createElement(Pie, { key: index, data: d, dataKey: serie.key, cx: "50%", cy: "50%", labelLine: index > 0, label: index === 0 ? renderCustomizedLabel : true, activeIndex: index, innerRadius: innerRadius, outerRadius: outerRadius },
                            colored &&
                                d.map(function (entry, dIndex) {
                                    return createElement(Cell, { key: dIndex, fill: randomColor() });
                                }),
                            !colored &&
                                d.map(function (entry, dIndex) {
                                    return createElement(Cell, { key: dIndex, fill: serie.color });
                                })));
                    }),
                !_this.props.hideLegend && createElement(Legend, null),
                createElement(Tooltip, null)));
        };
        _this.state = {
            loadingDataSource: false,
            data: _this.props.data,
            offSeries: {},
        };
        return _this;
    }
    Chart.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.dataSource) {
            var promise = typeof this.props.dataSource === "object" ? this.props.dataSource : this.props.dataSource();
            this.setState({
                loadingDataSource: true,
            });
            promise
                .then(function (result) {
                _this.setState({
                    data: result,
                    loadingDataSource: false,
                });
            })
                .catch(function (error) {
                _this.setState({
                    loadingDataSource: false,
                });
                if (_this.props.onDataSourceError) {
                    _this.props.onDataSourceError(error);
                }
            });
        }
    };
    Chart.prototype.componentWillReceiveProps = function (props) {
        if (!this.props.dataSource) {
            this.setState({
                data: props.data,
            });
        }
    };
    Chart.prototype.render = function () {
        var _this = this;
        var classes = this.props.classes;
        var height = this.props.height || 320;
        var loadingElementStyles = {
            position: "absolute",
            top: 0,
            display: "flex",
            alignItems: "center",
            height: height,
            width: "100%",
            textAlign: "center",
        };
        if (randomColor) {
            this.props.series.forEach(function (serie) {
                if (!serie.color) {
                    serie.color = randomColor();
                }
                if (_this.props.type && !serie.type) {
                    serie.type = _this.props.type;
                }
            });
        }
        return (createElement("div", { className: classnames(classes && classes.root, this.props.className), style: {
                position: "relative",
                width: this.props.width,
                height: height,
            } },
            this.props.type !== "pie" && this.renderCromposedChart(),
            this.props.type === "pie" && this.renderPieChart(),
            this.state.loadingDataSource && this.props.loadingElement && (createElement("div", { className: classnames(classes && classes.loadingElement), style: loadingElementStyles },
                createElement("div", { style: { flex: 1 } }, this.props.loadingElement)))));
    };
    return Chart;
}(Component));

export { Chart };
//# sourceMappingURL=recharts-wrapper.es5.js.map
